import type { ChangeEvent, FC } from "react";

import { Loader } from "@components/Loader";
import { PropertyListingAddress } from "@components/PropertyListingAddress";
import { PropertyListingPrice } from "@components/PropertyListingPrice";
import { PropertyListingImage } from "@components/PropertyListingImage";

interface Props {
  handleFormSubmit: (value: string) => void;
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  propertyListings: any; // TODO: Change whenever this is sourced from GQL
  searchQuery: string | undefined;
}

const PropertyListingsSearchResults: FC<Props> = ({
  handleFormSubmit,
  loading,
  propertyListings,
  searchQuery,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    handleFormSubmit(e.target.value);
  };

  const getAttributeNodes = (attribute: string, labelContent: string) => {
    if (attribute) {
      return (
        <tr>
          <td className="red">{labelContent}</td>
          <td>{attribute}</td>
        </tr>
      );
    }
  };

  const getPropertyListingClassName = () => {
    if (propertyListings) {
      return "small-12 medium-8 columns";
    }

    return "margin-top-container small-12 medium-5 columns";
  };

  return (
    <div id="property-listings-search-results-component" className={getPropertyListingClassName()}>
      <input
        type="text"
        id="search_query"
        className="search-input"
        placeholder="Search using an Address or Postal Code"
        title="Enter your search query here."
        autoComplete="off"
        onChange={handleChange}
        autoFocus
      />

      <Loader loading={loading} />
      {!loading && propertyListings && propertyListings.length == 0 && (
        <p className="text-center">{`No results found for: ${searchQuery}`}</p>
      )}
      {propertyListings &&
        propertyListings.length > 0 &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        propertyListings.map((propertyListing: any) => {
          return (
            <div className="row property-listing" key={propertyListing.id}>
              <a
                className="property-listing-link"
                href={`/property_listings/${propertyListing.slug}`}
              >
                <div className="row">
                  <div className="small-12 medium-3 columns">
                    <PropertyListingImage propertyListing={propertyListing} lazy />
                    <PropertyListingAddress propertyListing={propertyListing} />
                  </div>

                  <div className="small-12 medium-9 columns">
                    <table>
                      <tbody>
                        <tr>
                          <td className="price">
                            <PropertyListingPrice propertyListing={propertyListing} />
                          </td>
                        </tr>
                        {getAttributeNodes(propertyListing.bathroom_total, "Bathrooms")}
                        {getAttributeNodes(propertyListing.bedrooms_total, "Bedrooms")}
                        {getAttributeNodes(propertyListing.property_type, "Property Type")}
                        {getAttributeNodes(propertyListing.size_total_text, "Land Size")}
                        {getAttributeNodes(propertyListing.listing_id, "MLS® Number:")}
                      </tbody>
                    </table>

                    <div className="show-for-medium-up">
                      <p className="description">{propertyListing.public_remarks}</p>
                    </div>

                    <span className="list-office-name">
                      {propertyListing.office && propertyListing.office.name}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          );
        })}
    </div>
  );
};

export { PropertyListingsSearchResults };
